import localForage from 'localforage';

export default {
  writeData: (key, data) => localForage.setItem(key, data),
  readData: async (key) => localForage.getItem(key),
  removeData: (key) => localForage.removeItem(key),
  clear: () => localForage.clear(),
};
